import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { styled } from '@mui/material/styles'
import { Box, Stack, AppBar, Toolbar, IconButton, Typography } from '@mui/material'
import AccountPopover from './AccountPopover'
import LanguagePopover from './LanguagePopover'
import Iconify from '../../../components/Iconify'
import { useTranslation } from 'react-i18next'

const HEADER_MOBILE = 64

const HEADER_DESKTOP = 70

const StyledRoot = styled(AppBar)(({ theme }) => ({
  boxShadow: 'none',
  borderBottom: `1px solid ${theme.palette.grey[800]}`
}))

const StyledToolbar = styled(Toolbar)(({ theme }) => ({
  minHeight: HEADER_MOBILE,
  backgroundColor: theme.palette.grey[900],

  [theme.breakpoints.up('lg')]: {
    minHeight: HEADER_DESKTOP,
    padding: theme.spacing(0, 5)
  }
}))

Header.propTypes = {
  onOpenNav: PropTypes.func
}

export default function Header ({ onOpenNav }: any) {
  const { i18n } = useTranslation()

  useEffect(() => {
    if (i18n.resolvedLanguage !== 'pt') {
      void i18n.changeLanguage('pt')
    }
  }, [])

  return (
    <StyledRoot>
      <StyledToolbar>
        <IconButton
          onClick={onOpenNav}
          sx={{
            mr: 1,
            color: 'text.primary',
            display: { lg: 'none' }
          }}
        >
          <Iconify icon="eva:menu-2-fill" />
        </IconButton>

        <Box sx={{ flexGrow: 1 }} />

        <Stack
          direction="row"
          alignItems="center"
          spacing={{
            xs: 2,
            sm: 2
          }}
        >
          <LanguagePopover />
          <AccountPopover />
        </Stack>
      </StyledToolbar>
    </StyledRoot>
  )
}
